import React, { useEffect, useState, useContext } from "react";
import {FormControlLabel, Popover, Checkbox
  } from "@mui/material";
import { useSelector, useDispatch } from "react-redux";
import FilterAltOutlinedIcon from '@mui/icons-material/FilterAltOutlined';
import FilterAltTwoToneIcon from '@mui/icons-material/FilterAltTwoTone';
import {
    setState,
} from "./defineSlice";

const SKUNamePopOver = () => {
    const [anchorEl, setAnchorEl] = useState(null);
    const dispatch = useDispatch();
    const define = useSelector((state) => state.define);
    const { gridData, searchText, filter_skuNumber,skuNameList, filter_customerTypes,filter_customerTrustLevels, filter_skuName, SKUList, selectedProduct } = define;

    const handleCheckboxChange = (category) => {
        let vals = filter_skuName.includes(category) ? filter_skuName.filter((c) => c !== category) : [...filter_skuName, category];
        dispatch(setState("filter_skuName", vals));
        let skuNumb = SKUList?.filter((item) => item.skuName === category).map((item) => item.skuNumber);
        let filterRow = JSON.parse(JSON.stringify(filter_skuNumber));
        for(let i = 0; i< skuNumb.length; i++){
          filterRow = filterRow.includes(skuNumb[i]) ? filterRow.filter((c) => c !== skuNumb[i]) : [...filterRow, skuNumb[i]];
        }
        dispatch(setState("filter_skuNumber", filterRow));
    };
    const handleHeaderClick = (event) => {
        event.stopPropagation();
        setAnchorEl(anchorEl ? null : event.currentTarget);
    };


    useEffect(()=>{
        let val = gridData?.filter((item) =>{
          return(
          (filter_customerTypes.length === 0 || filter_customerTypes.some(type => item.type.toLowerCase().includes(type.toLowerCase()))) &&
          (filter_customerTrustLevels.length === 0 || filter_customerTrustLevels.some(level => item.customerTrustLevel.toLowerCase().includes(level.toLowerCase()))) &&
          (filter_skuName.length === 0 || filter_skuName.some(sku => item.skuName.toLowerCase().includes(sku.toLowerCase()))) &&
          (selectedProduct.packGroupOrSKUID === 0 || selectedProduct.packGroupOrSKUID === undefined || item.skuid === selectedProduct.packGroupOrSKUID || item.productGroupID === selectedProduct.packGroupOrSKUID) &&
          (item.skuName?.toLowerCase().includes(searchText) ||
          item.skuNumb?.toLowerCase().includes(searchText) ||
          item.customerName?.toLowerCase().includes(searchText) ||
          item.customerGroupName?.toLowerCase().includes(searchText) ||
          item.customerNumber?.toLowerCase().includes(searchText))
          );});
        dispatch(setState("gridDataFiltered", val));
    },[filter_skuName]);

    const handleCloseTrust = () => {
        setAnchorEl(null);
    };

    return(
        <div>
        <div
        style={{ display: 'flex', justifyContent: 'space-between', wordWrap: 'break-word', whiteSpace: 'pre-wrap', fontSize: '14px', cursor: 'pointer', lineHeight: '1.2' }}> 
        <span style = {{fontWeight:"700"}}>SKU / PG{"  "}</span> 
        <div onClick={handleHeaderClick}>
        {filter_skuName?.length === 0 &&<FilterAltOutlinedIcon style={{ color: '#bcbcba', fontSize : '20px'}} />}
        {filter_skuName?.length > 0 && <FilterAltTwoToneIcon style={{ color: '#6f6f6c', fontSize : '20px'}} />}
        </div>
        </div>

        <Popover
        open={Boolean(anchorEl)}
        anchorEl={anchorEl}
        onClose={handleCloseTrust}
        anchorOrigin={{
          vertical: 'bottom', horizontal: 'center',
        }}
        transformOrigin={{
          vertical: 'top', horizontal: 'center',
        }}
      >
        <div style={{ padding: 16, maxHeight: '200px', overflowY: 'auto' }}>
          {skuNameList?.map((item) => (
            <FormControlLabel
              control={
                <Checkbox
                  checked={filter_skuName.includes(item)}
                  onChange={() => handleCheckboxChange(item)}
                />
              }
              label={item}
              key={item}
              style={{ display: 'block' }}
            />
          ))}
        </div>
      </Popover>
      </div>
    );
}
export default SKUNamePopOver;